<template></template>

<script>
export default {
  name: "Unauthorized",
};
</script>

<style scoped>
</style>